import React from 'react';
import ManageRentalsShared from '../../Landlord/components/ManageRentals';

const ManageRentals = () => <ManageRentalsShared isAgentView />;

export default ManageRentals;
